import React from 'react'
import { ResponsiveContainer, AreaChart, CartesianGrid, XAxis, YAxis, Tooltip, Area } from 'recharts'

const LineDashboardChart = ({
	containerProps,
	areaChartProps,
	xAxisProps,
	yAxisProps,
	tooltipProps,
	series
}) => {
	return (
		<ResponsiveContainer {...containerProps}>
			<AreaChart {...areaChartProps}>
				<defs>
					{series.map(({ color }, index) => {
						return (
							<linearGradient key={`${color}${index}`} id={`color${index}${color}`} x1='0' y1='0' x2='0' y2='1'>
								<stop offset='56%' stopColor={color} stopOpacity={0.17} />
								<stop offset='100%' stopColor={color} stopOpacity={0} />
							</linearGradient>
						)
					})}
				</defs>
				<CartesianGrid strokeDasharray='3 3' vertical={false} />
				<XAxis {...xAxisProps} />
				<YAxis allowDecimals={false} {...yAxisProps} />
				<Tooltip {...tooltipProps} />
				{series.map(({ color, value }, index) => {
					return (
						<Area
							key={`${color}${value}${index}`}
							type='monotone'
							fillOpacity={1}
							dataKey={value}
							stroke={color}
							fill={`url(#color${index}${color})`}
						/>
					)
				})}
			</AreaChart>
		</ResponsiveContainer>
	)
}

export default LineDashboardChart
